import { type SignIn } from '@logto/schemas';

import PasswordSignInForm from '@/components/PasswordSignInForm';

import styles from './index.module.scss';

type Props = {
  readonly signInMethods: SignIn['methods'];
};

const Main = ({ signInMethods }: Props) => {
  const passwordMethods = signInMethods.filter(({ password }) => password);

  if (signInMethods.length > 0) {
    return (
      <PasswordSignInForm
        className={styles.main}
        signInMethods={passwordMethods.map(({ identifier }) => identifier)}
        verificationCodeMethods={signInMethods
          .filter(({ verificationCode }) => verificationCode)
          .map(({ identifier }) => identifier)}
      />
    );
  }

  return null;
};

export default Main;
